import {
  type Documentation,
  documentationSchema,
  type OldReport,
  oldReportSchema,
} from '@si/types';
import { get } from '@si/utils';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { queryKeys } from './queryKeys';

const responseSchema = z.object({
  reports: z.array(documentationSchema),
  oldReports: z.array(oldReportSchema),
});

interface Params {
  projectId: string;
  noRetry?: boolean;
}

export function useReports({ projectId, noRetry = false }: Params) {
  const url = `/projects/${projectId}/reports`;

  const { data, error, isLoading, refetch, isFetching } = useQuery<{
    reports: Documentation[];
    oldReports: OldReport[];
  }>({
    queryKey: queryKeys.getReports(projectId),
    queryFn: () => get({ url, schema: responseSchema }),
    enabled: !!projectId,
    retry: !noRetry,
  });

  return {
    reports: data?.reports || [],
    oldReports: data?.oldReports || [],
    error,
    isLoading,
    isFetching,
    refetch,
  };
}
